import { render, staticRenderFns } from "./profile-2.vue?vue&type=template&id=2eb6ec7a&"
import script from "./profile-2.vue?vue&type=script&lang=js&"
export * from "./profile-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports